import styles from "../../../styles/Participant-Employment.module.css"
const FormMenuItem = ({ activeForm, setActiveForm, value, label }) => {
  return (
    <div
      className={`${styles.link} ${activeForm === value && styles.link_active}`}
      onClick={() => {
        setActiveForm(value)
      }}
    >
      <span>{label}</span>
    </div>
  )
}
export default FormMenuItem
